// extracted by mini-css-extract-plugin
export var modal = "_kr-0";